import EmployeeListItem from "./EmployeeListItem";

export default function EmployeeList(props) {
  return (
    <div className="employeeList">
      <EmployeeListItem/>
    </div>
  );
}
